<template>
  <q-page class="column no-wrap bg-white">
    <DatabaseSync class="col-grow" />
  </q-page>
</template>

<script setup lang="ts">
import DatabaseSync from 'components/DatabaseSync.vue'
</script>
